import _ from 'lodash'

export default ({ modelReadingTypes }) =>
  _.map(modelReadingTypes, 'readingType')
